import { interfaces } from 'inversify';
import React, { Component, ComponentType } from 'react';

export type DependenciesMap = {
  [key: string]: symbol;
};

export function createWithInjectedPropsFunc(container: interfaces.Container) {
  return <P, S = {}>(
    ComponentToWrap: ComponentType<P>,
    dependenciesMap: DependenciesMap,
    displayName?: string,
  ): ComponentType<P & any> => {
    class WrappedComponent extends Component<P, S> {
      private readonly dependencies: Partial<P>;

      public static defaultProps = {} as P;

      constructor(props) {
        super(props);
        this.dependencies = this.createDependencies();
      }

      private createDependencies(): Partial<P> {
        return Object.entries(dependenciesMap).reduce<Partial<P>>(
          (acc, [key, type]) => {
            if (!container.isBound(type)) {
              throw new Error(`${key} is not bound to registered container`);
            }

            acc[key] = container.get(type);

            return acc;
          },
          {},
        );
      }

      public render() {
        return <ComponentToWrap {...this.dependencies} {...this.props} />;
      }
    }

    (WrappedComponent as any).displayName =
      displayName ||
      ComponentToWrap.displayName ||
      'withInjectedProps(Unknown)';

    return WrappedComponent;
  };
}
